import axios from "lib/api";
import { useEffect, useState } from "react";
import { mapObjectionsToUi } from "modules/shared/profiles/mapObjectionsToUi";
import { mapDrivertoUi } from "../mapUiToData";

const useFetchDriver = (driverId, included) => {
    const [fetchedDdata, setFetchedData] = useState({});
    const [initialDriver, setInitialDriver] = useState({});
    const [fetchedAttachments, setAttachments] = useState([]);
    const [paymentMethodId, setPaymentId] = useState();
    const [objections, setObjections] = useState({});

    const fetchingDriver = async () => {
        await axios
            .get(`drivers/${+driverId}`, {
                params: {
                    include: `${included}`,
                },
            })
            .then((res) => {
                setFetchedData(mapDrivertoUi(res));
                setInitialDriver(mapDrivertoUi(res));
                // eslint-disable-next-line no-shadow
                const included = res?.included;
                // eslint-disable-next-line consistent-return, array-callback-return
                const attachments = included?.map((item) => {
                    if (item?.type === "attachments") {
                        return { ...item?.attributes, id: item?.id };
                    }
                });
                setAttachments(attachments);
                const paymentId = included?.filter((item) => item?.type === "paymentMethods");
                setPaymentId(paymentId?.[0]?.id);
                setObjections(mapObjectionsToUi(included));
            })
            .catch((er) => {
                console.log(er);
            });
    };
    useEffect(() => {
        fetchingDriver();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [driverId]);
    return {
        fetchedDdata,
        initialDriver,
        fetchedAttachments,
        setAttachments,
        paymentMethodId,
        setFetchedData,
        fetchingDriver,
        objections,
    };
};

export default useFetchDriver;
